import React, { useState } from 'react'
import { Autocomplete, Paper, TextField } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface Option {
    label: string
    value: string
  }

interface AutoCompleteSelectProps {
  options: Option[]
  onChange: (newValue: string[]) => void
  value: string[],
  label: string,
  limitTags: number,
  maxLength: number
}

const AutoCompleteSelect = ({ options, onChange, value, label, limitTags, maxLength }: AutoCompleteSelectProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const hasLongValue = options.filter(opt => value.includes(opt.value)).some(opt => opt.value.length > maxLength);
  const limitTagsValue = hasLongValue ? 1 : limitTags;

    return (
        <Autocomplete
            multiple
            sx={{ 
              width: '100%', 
              padding: 0,
              backgroundColor: '#fff',
              borderRadius: '30px',
               '& .MuiAutocomplete-endAdornment': {
                right: '17px !important', 
              },
               '& .MuiAutocomplete-clearIndicator': {
                '& svg': {
                  fontSize: '18px',
                }
              }
            }}
            options={options.sort((a, b) => a.label.localeCompare(b.label))}
            limitTags={limitTagsValue}
            value={options.filter(opt => value.includes(opt.value))}
            getOptionLabel={(option) => option.label}
            onChange={(event, newValue) => onChange(newValue.map(opt => opt.value))}
            popupIcon={<KeyboardArrowDownIcon sx={{ width: '18px', height: '18px', color: '#1D1B20' }} />}
            renderInput={(params) => (
            <TextField
                {...params}
                label={value.length === 0 && !isFocused ? label : ''}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                InputLabelProps={{
                    shrink: false,
                    sx: {
                      '&.Mui-focused': {
                        color: '#9135E0',
                      },
                      fontSize: '14px',
                      marginTop: '2.5px',
                      color: 'rgb(107, 114, 128)',
                      fontFamily: 'InterRegular',
                      fontWeight: '400 !important',
                    },
                    
                  }}
                sx={{
                    borderRadius: "30px",
                    '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#E5E5E5',
                    },
                    minHeight: '42px',
                    height: 'auto',
                    '&:hover fieldset': {
                      borderColor: '#A0A0A4',
                    },
                    '&.Mui-focused fieldset': {
                    borderColor: '#9135E0',
                    fontSize: '20px',
                    },
                    '&.MuiInputBase-root':{
                      borderRadius: '30px',
                      backgroundColor: '#fff !important'
                    }
                },
                }}

            />
            )}
            ChipProps={{
                sx: {
                    fontSize: '14px',
                    fontFamily: 'InterRegular',
                    marginTop: '8px !important',
                },
                size: 'small',
            }}
            PaperComponent={(props) => (
                <Paper {...props} sx={{ 
                  fontSize: '14px !important' ,
                  borderRadius: '16px',
                }} />
            )}
            ListboxProps={{
              sx: {
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  overflow: 'auto',
                  '& .MuiAutocomplete-option': {
                  backgroundColor: '#FFF',

                  '&:nth-of-type(even)': {
                    backgroundColor: '#F7F8FA',
                  },
                  '&[aria-selected="true"]': {
                    backgroundColor: '#EEF0F4 !important',
                  },

                  '&.Mui-focused': {
                    backgroundColor: '#EEF0F4',
                  },
              }
            }
          }}
        />
    )
}
export default AutoCompleteSelect